import { ResetPasswordComponent } from './auth/reset-password/reset-password.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './auth/services/auth-guard.service';
import { ForgetPasswordComponent } from './auth/forget-password/forget-password.component';
import { NotFoundComponent } from './shared/component/not-found/not-found.component';

const AppRoutes: Routes = [
  { path: 'signin', loadChildren: 'app/auth/auth.module#AuthModule' },
  { path: 'forget-password', component: ForgetPasswordComponent },
  { path: 'reset-password/:token', loadChildren: 'app/auth/reset-password/reset.module#ResetPasswordModule' },
  { path: '', loadChildren: 'app/admin/admin.module#AdminModule', canActivate: [AuthGuard] },
  { path: 'not-found', component: NotFoundComponent },
  { path: '**', redirectTo: 'not-found' }
];

@NgModule({
  imports: [
    RouterModule.forRoot(AppRoutes, {
      enableTracing: false ,
      useHash: true
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }





// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts